// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.replyList {\n  height: 60vh;\n  overflow: auto;\n}\n.merge-dropdown {\n  width: 420px !important;\n  max-height: 60vh;\n  overflow: auto;\n  margin-right: 10px !important;\n}\n.merge-dropdown-button {\n  text-transform: capitalize !important;\n  letter-spacing: 1px !important;\n  margin-top: 20px;\n  padding: 0 0 0 0 !important;\n  height: 40px !important;\n}\n", ""]);
// Exports
module.exports = exports;
